export default "__VITE_ASSET__C02NVynU__"